import {
  buildOrderLiteral,
  buildPagingLiteral,
  buildWhereLiteral,
  OrderBy,
} from '@/lib/graphql-query-builder';

/**
 * The Data Gateway's `get<Schema>s` queries take native `where` / `order` / `paging` arguments
 * instead of a single JSON-string `input: DynamicQueryInput` — see graphql-query-builder.ts for
 * why these are inlined as literals rather than passed as typed variables. Paged lists sort on the
 * server (`buildOrderLiteral`), so each page is a slice of the sorted whole.
 *
 * Schema: TimeSheet (verified live in Blocks OS against the .NET TimeSheet domain).
 *
 * Latest change first by default, like the old timesheet list's `{ LastUpdateDate: -1 }` sort.
 */
export const DEFAULT_MY_TIMESHEETS_ORDER: OrderBy[] = [
  { field: 'LastUpdatedDate', direction: 'DESC' },
];

export const buildGetTimeSheetsQuery = (
  where: Record<string, unknown>,
  pageNo: number,
  pageSize: number,
  order: OrderBy[] = DEFAULT_MY_TIMESHEETS_ORDER
) => `
  query {
    TimeSheets: getTimeSheets(
      where: ${buildWhereLiteral(where)}
      order: ${buildOrderLiteral(order)}
      paging: ${buildPagingLiteral(pageNo, pageSize)}
    ) {
      hasNextPage
      hasPreviousPage
      totalCount
      totalPages
      pageSize
      pageNo
      items {
        ItemId
        CreatedDate
        LastUpdatedDate
        UserId
        DisplayName
        Email
        DepartmentId
        Organization
        IsUnderTime
        TaskDate
        TasksJson
        CustomerIds
        ProjectIds
      }
    }
  }
`;

// Schema: MbmProject -- read-only lookup catalog used to populate the
// project/customer picker on each timesheet task row.
export const buildGetMbmProjectsLookupQuery = (
  where: Record<string, unknown>,
  pageNo: number,
  pageSize: number
) => `
  query {
    MbmProjects: getMbmProjects(
      where: ${buildWhereLiteral(where)}
      order: []
      paging: ${buildPagingLiteral(pageNo, pageSize)}
    ) {
      totalCount
      items {
        ItemId
        ProjectId
        ProjectName
        CustomerId
        CustomerName
        Status
      }
    }
  }
`;
